import { useProjectSettingsQueryContext } from '../../contexts';
import { AudienceFormSection } from './AudienceFormSection';
import { ContentFormSection } from './ContentFormSection';
import { EmailFormSection } from './EmailFormSection';
import { InsightsFormSection } from './InsightsFormSection';
import { MessagingFormSection } from './MessagingFormSection';
import { TrackingFormSection } from './TrackingFormSection';
import { ProjectFormSection } from './ProjectFormSection';
import { SmsFormSection } from './SmsFormSection';

export const ProjectSettingsForm = () => {
  const { project } = useProjectSettingsQueryContext();

  if (!project || Object.keys(project).length === 0) return null;
  return (
    <form
      onSubmit={(e) => {
        /**
         * TODO: handle form submission -- preventDefault currently necessary
         * to prevent form submission on click of Campaign Label ActionMenu
         * options.
         */
        e.preventDefault();
      }}
    >
      <ProjectFormSection />
      <MessagingFormSection />
      <EmailFormSection />
      <SmsFormSection />
      <ContentFormSection />
      <AudienceFormSection />
      <InsightsFormSection />
      <TrackingFormSection />
    </form>
  );
};
